export default "__VITE_ASSET__5942bf03__"